import { render } from "./ImagePickField.vue?vue&type=template&id=5b8bf716&scoped=true"
import script from "./ImagePickField.vue?vue&type=script&lang=js"
export * from "./ImagePickField.vue?vue&type=script&lang=js"

import "./ImagePickField.vue?vue&type=style&index=0&id=5b8bf716&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b8bf716"]])

export default __exports__